import React, { useState, useEffect } from "react";
import Pagination from "../../components/global/pagination/Pagination.jsx";
import columns from "../../columns/MT5Account/MT5PendingAccounts.js";
import TableWithSkeleton from "../../components/global/table/TableWithSkeleton.jsx";
import ConfirmationModal from "../../components/global/modal/ConfirmationModal.jsx";
import ModalComponent from "../../components/global/modal/ModalComponent.jsx";
import { GetAllAccountApi, MT5RequestAcceptRejectApi } from "../../api/request/account.js";
import toast from "react-hot-toast";
import moment from "moment";
import UserAvatar from "../../components/global/avtar/UserAvatar.jsx";
import { Select } from "antd";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import useModulePermissions from "../../hooks/useModulePermissions.jsx";

const MAX_LEVERAGE_OPTIONS = [
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: 200, label: "200" },
    { value: 300, label: "300" },
    { value: 400, label: "400" },
    { value: 500, label: "500" },
    { value: 600, label: "600" },
    { value: 700, label: "700" },
    { value: 800, label: "800" },
    { value: 900, label: "900" },
    { value: 1000, label: "1000" },
];

export default function Accounts({ dates }) {

    const accountPermissions = useModulePermissions('account');
    const canAcceptReject = !!accountPermissions.accept_reject;

    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [data, setData] = useState([]);
    const [mt5Accept, setMT5Accept] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState('');
    const [mt5Rejection, setMT5Rejection] = useState(false);
    const [isReqLoading, setIsReqLoading] = useState(false);
    const [selectedmt5, setSelectedMT5] = useState({ userId: null, mT5Id: null });
    const [sorter, setSorter] = useState({ SortBy: 'createdDate', SortOrder: '' });
    const [maxLeverage, setMaxLeverage] = useState(null);
    const [maxLeverageError, setMaxLeverageError] = useState('');


    const setSelectedMT5Id = (userId, mT5Id) => {
        setSelectedMT5({ userId, mT5Id });
    };


    const getAllmt5 = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                SearchText: dates,
                FilterText: "Pending",
                ...sorter
            }
            setIsLoading(true);
            const { data } = await GetAllAccountApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        const { userId, mT5Id } = item;

                        return {
                            ...item,
                            userDetails: (<UserAvatar data={{ name: item?.name, email: item?.email, profileImage: item?.profileImage }} />),
                            balance: `$ ${item?.balance}`,
                            createdDate: (item?.createdDate ? moment(item?.createdDate).format("DD-MM-YYYY, hh:mm A") : null),

                            actions: (
                                <div className="flex">
                                    <button
                                        className="mr-3 ml-3"
                                        onClick={() => {
                                            setSelectedMT5Id(userId, mT5Id);
                                            setMT5Accept(true);
                                        }}
                                    >
                                        <img src="assets/icons/accept_icon.svg" alt="icon" width={27} />
                                    </button>
                                    <button onClick={() => {
                                        setSelectedMT5Id(userId, mT5Id);
                                        setMT5Rejection(true)
                                    }}><img src="assets/icons/delete_icon.svg" alt="icon" width={27} /></button>
                                </div>
                            ),
                        };
                    })
                );
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }
    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'createdDate', SortOrder: '' });
        }
    };

    useEffect(() => {
        getAllmt5();
    }, [page, pageSize, filter, sorter, dates]);

    useEffect(() => {
        setPage(1);
    }, [dates]);

    const MT5RequestHandlerApproved = async (selectedMaxLeverage) => {
        if (!selectedMaxLeverage) {
            setMaxLeverageError('Please select Max Leverage.');
            return;
        }
        setMaxLeverageError('');
        try {
            setIsReqLoading(true);
            let params = {
                isRejected: false,
                isApproved: true,
                comment: textAreaValue ? textAreaValue : 'Accepted.',
                userId: selectedmt5?.userId,
                mT5Id: selectedmt5?.mT5Id,
                maxLeverage: selectedMaxLeverage,
            };
            const { data } = await MT5RequestAcceptRejectApi(params);
            if (data?.success) {
                toast.success(data?.message);
                getAllmt5();
                setMT5Accept(false);
                setMaxLeverage(null);
            }
            setIsReqLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setIsReqLoading(false);
        }
    };

    const handleCloseAcceptModal = () => {
        if (!isReqLoading) {
            setMT5Accept(false);
            setMaxLeverage(null);
            setMaxLeverageError('');
        }
    };

    const MT5RequestHandlerRejected = async () => {
        if (!textAreaValue) {
            toast.error('Please enter a reason.');
            return;
        }
        try {
            setIsReqLoading(true);
            let params = {
                isRejected: true,
                isApproved: false,
                comment: textAreaValue ? textAreaValue : 'Accepted.',
                userId: selectedmt5?.userId,
                mT5Id: selectedmt5?.mT5Id

            }
            const { data } = await MT5RequestAcceptRejectApi(params);
            if (data?.success) {
                toast.success(data?.message);
                getAllmt5();
                setTextAreaValue('');
            }
            setIsReqLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setIsReqLoading(false);
        }
        setMT5Rejection(false);
    }

    return (
        <div>
            <div className="my-6">
                <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
                    <TableWithSkeleton
                            columns={columns}
                            data={data}
                            loading={isLoading}
                            onChange={handleTableChange}
                            hiddenColumns={!canAcceptReject ? ["Actions"] : []}
                            page={page}
                            pageSize={pageSize}
                        />
                </div>
                <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
            </div>

            <ModalComponent
                isOpen={mt5Accept}
                setIsOpen={(val) => { setMT5Accept(val); if (val === false) { setMaxLeverage(null); setMaxLeverageError(''); } }}
                title="Accept Account Request"
                width={420}
            >
                <div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2F2B3D] mb-2">Max Leverage <span className="text-red-500">*</span></label>
                        <Select
                            size="large"
                            placeholder="Select Max Leverage"
                            className="w-full"
                            value={maxLeverage}
                            onChange={(val) => { setMaxLeverage(val); setMaxLeverageError(''); }}
                            options={MAX_LEVERAGE_OPTIONS}
                            status={maxLeverageError ? 'error' : ''}
                        />
                        {maxLeverageError && <p className="text-red-500 text-sm mt-1">{maxLeverageError}</p>}
                    </div>
                    <div className="flex justify-end items-center gap-5 mt-6">
                        <button
                            onClick={handleCloseAcceptModal}
                            disabled={isReqLoading}
                            className="bg-[#D91819] text-sm text-white font-medium px-10 py-2 rounded-lg hover:bg-[#aa0001] duration-500"
                        >
                            Cancel
                        </button>
                        <LoadableButton
                            className="bg-[#2D9B63] text-sm text-white font-medium px-10 py-2 rounded-lg hover:bg-[#096034] duration-500"
                            onClick={() => MT5RequestHandlerApproved(maxLeverage)}
                            disabled={isReqLoading}
                            lable="Confirm"
                            isLoading={isReqLoading}
                            loadingLable="Accepting..."
                        />
                    </div>
                </div>
            </ModalComponent>

            {/* ---- Reject-request ---- */}
            <ConfirmationModal
                isOpen={mt5Rejection}
                setIsOpen={setMT5Rejection}
                message='Are you sure you want to reject this request?'
                onConfirm={MT5RequestHandlerRejected}
                isLoading={isReqLoading}
                loadingLabel='Rejecting request...'
                textArea={true}
                textAreaValue={textAreaValue}
                setTextAreaValue={setTextAreaValue}
                placeholder='Reason of rejection...'
            />
        </div>
    )
}
